import { Route } from '@angular/router';
import { gamesLocalLeaveBusterGuard } from 'src/app/modules/games/guards/games-local-leave-buster.guard';

export const cricketTacticsLocalGameRoutes: Route[] = [
    {
        path: 'local-games/cricket-tactics',
        loadComponent: () =>
            import('./pages/cricket-tactics-new-game/cricket-tactics-new-game.component').then(
                (c) => c.CricketTacticsNewGameComponent
            ),
    },
    {
        path: 'game/cricket-tactics',
        canDeactivate: [gamesLocalLeaveBusterGuard],
        loadComponent: () =>
            import('./pages/cricket-tactics-local-game-app/cricket-tactics-local-game-app.component').then(
                (m) => m.CricketTacticsLocalGameAppComponent
            ),
    },
];

export const cricketTacticsVenueLocalGameRoutes: Route[] = [
    {
        path: 'local-games/cricket-tactics',
        loadComponent: () =>
            import('./pages/cricket-tactics-new-game/cricket-tactics-new-game.component').then(
                (c) => c.CricketTacticsNewGameComponent
            ),
    },
    {
        path: 'game/cricket-tactics',
        canDeactivate: [gamesLocalLeaveBusterGuard],
        loadComponent: () =>
            import('./pages/cricket-tactics-local-game-venue/cricket-tactics-local-game-venue.component').then(
                (m) => m.CricketTacticsLocalGameVenueComponent
            ),
    },
];
